import EnumAutocomplete from './EnumAutocomplete';
import ParametresRechercheAvancee from './ParametresRechercheAvancee';
import DialogModifMasse from './DialogModifMasse';

import EntitySearch from './EntitySearch';
import DateSearch from './DateSearch';
import DialogSauvegardeRecherche from './DialogSauvegardeRecherche';
import DialogSupprimeRecherche from './DialogSupprimeRecherche';

export default {
  install(Vue) {
    Vue.component('dialogModifMasse', DialogModifMasse);
    Vue.component('parametresRechercheAvancee', ParametresRechercheAvancee);
    Vue.component('enumAutocomplete', EnumAutocomplete);
    Vue.component('entitySearch', EntitySearch);
    Vue.component('dateSearch', DateSearch);
    Vue.component('dialogSauvegardeRecherche', DialogSauvegardeRecherche);
    Vue.component('dialogSupprimeRecherche', DialogSupprimeRecherche);
  },
};
